"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteKeysLike = exports.deleteKey = exports.save = exports.load = void 0;
var storerCompressor_sidecar_1 = require("./storerCompressor-sidecar");
function load(localStorageKey, version) {
    try {
        var str = localStorage.getItem(localStorageKey);
        if (str) {
            var idx1 = str.indexOf(':');
            if (idx1 === -1) {
                return null;
            }
            var idx2 = str.indexOf(':', idx1 + 1);
            if (idx2 === -1) {
                return null;
            }
            var idx3 = str.indexOf(':', idx2 + 1);
            if (idx3 === -1) {
                return null;
            }
            var version_1 = str.substring(idx1 + 1, idx2);
            console.log('version', version_1);
            if (version_1 !== version_1) {
                return null;
            }
            var compression = str.substring(idx2 + 1, idx3);
            console.log('compression', compression);
            var data = str.substring(idx3 + 1);
            var isCompressed = compression === 'lz';
            if (isCompressed) {
                return JSON.parse(storerCompressor_sidecar_1.storerCompressor.decompress(data));
            }
            else {
                return JSON.parse(data);
            }
        }
    }
    catch (err) {
        console.error('failed to load', localStorageKey, localStorage.getItem(localStorageKey));
    }
}
exports.load = load;
function save(localStorageKey, version, data, compress) {
    if (compress === void 0) { compress = false; }
    var str = 'version:' + version + ':' + (compress ? 'lz' : 'raw') + ':';
    if (compress) {
        str += storerCompressor_sidecar_1.storerCompressor.compress(JSON.stringify(data));
    }
    else {
        str += JSON.stringify(data);
    }
    localStorage.setItem(localStorageKey, str);
    console.log('saver', localStorageKey, 'wrote', str.length, 'chars');
}
exports.save = save;
function deleteKey(localStorageKey) {
    localStorage.removeItem(localStorageKey);
}
exports.deleteKey = deleteKey;
function deleteKeysLike(prefix) {
    for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (key && key.startsWith(prefix)) {
            deleteKey(key);
        }
    }
}
exports.deleteKeysLike = deleteKeysLike;
